import { observable } from 'mobx';
import firebase from 'firebase';

import * as moment from 'moment';

var authStore = observable({
  init() {
    firebase.auth().onAuthStateChanged(user => {
      this.user = user;
    });
  },

  signIn(email, password) {
    if (this.authUser) {
      return Promise.resolve(this.authUser);
    }
    return firebase.auth().signInWithEmailAndPassword(email, password);
  },

  signOut() {
    firebase.auth().signOut();
  },

  get initialising() {
    return this.user === undefined;
  },

  get ready() {
    return !this.initialising;
  },

  get isSignedIn() {
    return !this.initialising && this.user !== null;
  },

  get profile() {
    return this.user
      ? {
          uid: this.user.uid,
          email: this.user.email,
          displayName: this.user.displayName,
          photoURL: this.user.photoURL,
          createdAt: moment(this.user.metadata.creationTime),
          lastSignInTime: moment(this.user.metadata.lastSignInTime)
        }
      : null;
  }
});
authStore.init();

export default authStore;
